import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@a-type/ui';
export function BugButton(props) {
    return (_jsx("a", { href: "mailto:hi@biscuits.club", target: "_blank", rel: "noopener noreferrer", children: _jsx(Button, Object.assign({ emphasis: "default" }, props, { children: "Report a bug" })) }));
}
//# sourceMappingURL=BugButton.js.map